/**
 * Created by fers on 29.04.16.
 */
import version from '../../build/version';

const PROJECT_DOMAIN = process.env.CONFIG_DOMAIN_PART ? process.env.CONFIG_DOMAIN_PART : "dativery.com";

const STAGE_NAME = process.env.CF_STAGE ? process.env.CF_STAGE : "prod";

const EXTENSION_VERSION = "0.6.7";
const AGENT_VERSION = "1.0.241";

/* in browser we have to remove CF_uiVersion to use compiled version in build/version.js */

const VERSION = version.version + "-" + version.buildDateCode;
const UI_VERSION = process.env.CF_uiVersion ? process.env.CF_uiVersion : VERSION;
const BACKUP_UI_VERSION = version.backupUIVersion;
const GLOBAL_CDN = process.env.CDN_HOSTNAME || process.env.CF_cdnDomain ? " https://" + process.env.CF_cdnDomain : "https://cdn-" + STAGE_NAME + ".d." + PROJECT_DOMAIN;
const PUBLIC_CDN = process.env.CDN_HOSTNAME || process.env.CF_cdnDomain ? "https://" + process.env.CF_cdnDomain + "/cdn" : GLOBAL_CDN + "/cdn";
const PUBLIC_APP_URL = process.env.APP_URL || (process.env.CF_appDomain ? 'https://' + process.env.CF_appDomain : "https://app." + PROJECT_DOMAIN); // no ending slash (/)
const PUBLIC_INTEGRATE_URL = (process.env.CF_integrateDomain ? 'https://' + process.env.CF_integrateDomain : (STAGE_NAME === "prod" ? ("https://hooks." + PROJECT_DOMAIN) : PUBLIC_APP_URL)) + '/api/v1'; // no ending slash (/)
const PUBLIC_CDN_URL = "/cdn/v/" + UI_VERSION; // no ending slash (/)
const GLOBAL_CDN_URL = PUBLIC_APP_URL + "/cdn/v/" + UI_VERSION; // no ending slash (/)
const API_PREFIX = "/api/v1"; // no ending slash (/)
const GLOBAL_API_URL = (process.env.CF_API_URL ? process.env.CF_API_URL : PUBLIC_APP_URL) + API_PREFIX; // no ending slash (/)
const PUBLIC_WEB_URL = "https://www." + PROJECT_DOMAIN;

const PUBLIC_INCOMING_DOMAIN = STAGE_NAME === "prod" || STAGE_NAME === "stage" ? "@mydativery.com" : "@" + STAGE_NAME + ".mydativery.com"; // must contain @

const isProduction = process.env.NODE_ENV && process.env.NODE_ENV === "development" ? false : true;
const PROJECT_NAME = 'dativery';

const config = {
    googleAnalyticsId: 'UA-66220924-2',
    isProduction: isProduction,
    VERSION: VERSION,
    PROJECT_DOMAIN: PROJECT_DOMAIN,
    PROJECT_NAME: PROJECT_NAME, // used in variable names
    PRODUCT_NAME: 'Dativery', // showed to user
    SALES_EMAIL: 'obchod@' + PROJECT_DOMAIN, // showed to user
    SUPPORT_EMAIL: 'hello@' + PROJECT_DOMAIN, // showed to user
    SUPPORT_URL: PUBLIC_WEB_URL + '/support/', // showed to user
    NO_REPLY_EMAIL: 'no-reply' + PUBLIC_INCOMING_DOMAIN,
    PUBLIC_CDN: PUBLIC_CDN,
    PUBLIC_CDN_URL: PUBLIC_CDN_URL,
    GLOBAL_API_URL: GLOBAL_API_URL,
    GLOBAL_CDN_URL: GLOBAL_CDN_URL,
    GLOBAL_CDN: GLOBAL_CDN,
    PUBLIC_APP_URL: PUBLIC_APP_URL,
    PUBLIC_WEB_URL: PUBLIC_WEB_URL,
    PUBLIC_INTEGRATE_URL: PUBLIC_INTEGRATE_URL,
    API_PREFIX: API_PREFIX,
    DEVEL_HOSTS: 'https://localhost:8000',
    UI_VERSION: UI_VERSION,
    BACKUP_UI_VERSION: BACKUP_UI_VERSION,
	AWS_REGION: 'eu-central-1',
    PUBLIC_INCOMING_DOMAIN: PUBLIC_INCOMING_DOMAIN,

    LINK_SERVER: 'https://link.' + PROJECT_DOMAIN,
    PUBLIC_HOOK_PROXY_URL: "https://hook-proxy." + PROJECT_DOMAIN,

    GROUP_DEF_ENTITIES: 'fdf4219f-eb2d-4c7b-8617-46096a6f52eb',
    GROUP_DEF_COMPONENTS: '06177f23-d9ee-46f5-9525-409560c8d50e',
    ENTITY_DEF_COMPANIES: 'ba7a4a0e-b403-4c22-9f97-e71b3a194459',
    ENTITY_DEF_CONTACTS: 'e2587b69-08e9-4131-8ea6-fe7c1dd54071',
    ENTITY_DEF_EMAIL_MESSAGES: '554a35b1-485b-49fe-b251-78863efd1427',
    ENTITY_DEF_CONVERSATIONS: '48c9dc98-bee4-49d0-9610-e37f118dba35',
    ENTITY_DEF_HELPDESK_TICKET: '5f2cdc66-04c9-4cbe-8665-285e60bed7b7',
    ENTITY_DEF_ISSUES: '23ac7747-298b-4509-8b43-a6de2c1c5dfd',
    ENTITY_DEF_PHONE_CALLS: '1a9971a0-05c2-4e0c-acfc-5f6731038b39',
    ENTITY_DEF_PRODUCT_REVIEWS: 'd98859cf-3a4d-40f2-8458-080bee580a70',
    ENTITY_DEF_SMS_MESSAGES: '40696825-5cb7-4fa0-b83c-7b4d6c1f484e',
    ENTITY_DEF_COMMENTS: '03123ac1-fc7d-4d36-82ed-18cbde8c575c',
    ENTITY_DEF_USERS: '8d1114bf-581b-4ce1-8d5b-a3698e1dee6d',
    ENTITY_DEF_PERSON: '996c0f69-143f-4ac8-816d-a9c6a5f084a2',
    ENTITY_DEF_ACTIVITIES: "c81df3a8-c2d4-407a-83bb-e35c87b79a90",
    ENTITY_DEF_PAYMENT_FORM: "9be3153a-b026-4b31-b156-8a4a4b1c9298",
    ENTITY_DEF_CONTRACT_PROJECTS: "10a9b0ea-24ae-4f0c-91d0-dd3f191105e2",
    ENTITY_DEF_CENTRES: "84bc12eb-25c3-494a-906e-753ed849609b",
    ENTITY_DEF_ACCOUNTING_RULES: "342d0d8f-aa1e-4b8f-95e5-9f466f3100a0",
    ENTITY_DEF_NUMERICAL_SERIES: "3b7ce757-ac7e-4053-b1e9-f46c6942c008",
    ENTITY_DEF_VAT_CLASSIFICATION: "b85df4d9-09a1-43b5-a319-bf4696ecd06d",
    ENTITY_DEF_ACCOUNT_PLANS: "0cf165ae-eb55-4b61-886f-cf341e0a3c1b",
    ENTITY_DEF_ISSUED_INVOICES: '434951d3-cf3d-4cfb-9e9a-dbd81ab6ed66',
    ENTITY_DEF_RECEIVED_INVOICES: 'bfcf23da-d5ee-42ae-b8b8-1404c6db1593',
    ENTITY_DEF_LIABALITIES: 'b51298c8-46d7-4920-99fe-f4491757059a',
    ENTITY_DEF_CASH_VOUCHERS: '28a1b105-2e98-4dd9-9b78-0ef351219221',

    ENTITY_DEF_COM_FULLCONTACT_EMAILLOOKUP: '4eae2bdb-b5b0-41e8-8549-7a14b9377772',
    ENTITY_DEF_COM_FULLCONTACT_COMPANIES: '1ed0491f-b3f2-41aa-aab9-fe83a47fecef',
    ENTITY_DEF_CZ_MERK_COMPANIES: '4fd045d0-6bf4-4cf5-95aa-1eb470d24662',
    ENTITY_DEF_CZ_FIRMO_COMPANIES: 'fe0e549f-083b-483a-adcf-395e29a7c0a5',

    CHANNEL_DEF_FLEXIBEE: 'f471171f-78ae-4866-b73b-79e142b1a8fb',
    CHANNEL_DEF_ROSSUM: 'd7ae4b98-4086-4768-bc77-7e8c6edcfd58',
    CHANNEL_DEF_POHODA: '101538db-48a5-4bb3-89a0-48c245735fff',
    CHANNEL_DEF_ABRA_GEN: '43e89e39-de3d-46fc-bdce-705a8d8162a8',
    CHANNEL_DEF_MERK: '3e64c649-2932-44f7-b177-fc106dd0bdc6',
    CHANNEL_DEF_FIRMO: '9f054f09-216a-44e9-b036-c999d107430e',
    CHANNEL_DEF_FULLCONTACT: '4d5090ae-ef71-49d3-9cc2-782372410e9f',
    CHANNEL_DEF_CREDITCHECK: '50d2005b-73fb-43f2-9ae8-d5aa36b1eba8',
    CHANNEL_DEF_IDOKLAD: 'a146d83b-e6c1-466f-baa9-225bcbed5145',
    CHANNEL_DEF_NOERP: '4c2a18de-1af3-42a6-8b75-e55348e68056',
    CHANNEL_DEF_6K: 'b8a29808-3255-4b7b-be16-d9e21dc57b57',
    CHANNEL_DEF_FIO: 'd3d8c02c-b6ff-4ebc-91dc-669c1f3e251a',
    CHANNEL_DEF_KB: 'bb6127c2-b081-440c-8d67-78e11da1f064',
    CHANNEL_DEF_UPGATES: "9ba5943b-00a2-4a6b-99e5-410e77a80a70",

    CHANNEL_DEF_COMPANY_SEARCH: '8891f331-6673-415c-9682-0ee3bcf52e6a',

    SOURCE_DEF_MERK_COMPANIES: '41a1c3c6-82d1-46c8-827f-b87d18332c49',
    SOURCE_DEF_MERK_FINANCIAL_STATEMENTS: '9d6dbf60-aca9-4b10-88ff-f040bbcec6e5',
    SOURCE_DEF_FIRMO_COMPANIES: 'ed6d0229-d9e5-4a2a-9771-0a01bb8bac4d',
    SOURCE_DEF_CREDITCHECK_SEMAPHORE: '803f1e9c-09a4-4f1e-a0ad-7879fef50e03',
    SOURCE_DEF_FULLCONTACT_EMAIL_LOOKUP: '3f212023-1338-4e3d-80d2-7fff4049410e',
    SOURCE_DEF_FULLCONTACT_COMPANIES: '2002bf09-a743-401c-a126-c2bc9f237182',

    FLOW_DEF_UPGATES_ORDERS: '836b5b0d-8917-43bc-9269-8f06f6a7b222',
    FLOW_DEF_UPGATES_INVOICES: '753bb274-22f8-45b6-b89f-4a109d6c9f69',

    FLOW_DEF_SHOPTET_ORDERS: '836b5b0d-8917-43bc-9269-8f06f6a7b222',
    FLOW_DEF_SHOPTET_INVOICES: '753bb274-22f8-45b6-b89f-4a109d6c9f69',
    FLOW_DEF_SHOPIFY_ORDERS: '836b5b0d-8917-43bc-9269-8f06f6a7b222',
    FLOW_DEF_SHOPIFY_INVOICES: '753bb274-22f8-45b6-b89f-4a109d6c9f69',

    FIELD_DEF_COMPANY_NAME_KEY: 'com.dativery.model.entities.companies@name',
    FIELD_DEF_COMPANY_NAME: '3c11e208-4c99-4d12-af4c-5bbaee20090b', // com.dativery.model.entities.companies@name

    INTERCOM_APP_ID: 'y08wvvn1',
    GOOGLE_KEY: 'AIzaSyBVDAS22dSKv_gAPWI2kScZKcsXdu29lUk',

    DEVELOPER_DATIVERY: 'bb824c00-881c-41f2-95b4-7362effed858',
    INSTANCE_DATIVERY: '4efef258-1b0a-4960-90b4-a6a383c76916',

    STAGE: STAGE_NAME,
    EXTENSION_VERSION: EXTENSION_VERSION,
    AGENT_VERSION: AGENT_VERSION,
    AGENT_URL: 'https://cdn.dativery.com/cdn/agent/dativery-agent-setup-' + AGENT_VERSION + '.exe',
	AGENT_LATEST_URL: 'https://cdn.dativery.com/cdn/agent/latest.yml',
	AGENT_PREFIX_URL: 'https://cdn.dativery.com/cdn/agent/',

    useSQL: process.env.useSQL && process.env.useSQL === "true" ? true : false,
};

export default config;
